import { SHBox, SHContainer, SHStack } from "@components/design-systems";
import SHSkeleton from "@components/design-systems/sh-skeleton";
import { useTheme } from "@mui/material";

export const BusinessMetricSelectionSkeleton = () => {
  const { palette, breakpoints } = useTheme();
  return (
    <SHContainer
      maxWidth={false}
      sx={{ maxWidth: breakpoints.values.lg2 - 80 }}
    >
      <SHStack gap={2} marginTop={3}>
        <SHStack spacing={2}>
          <SHSkeleton
            height={35}
            width={120}
            variant={"rounded"}
            delay={false}
          />
          <SHSkeleton
            height={40}
            width={350}
            variant={"rounded"}
            delay={false}
          />
        </SHStack>

        {Array.from(Array(3).keys()).map((index) => (
          <SHStack key={index} spacing={2}>
            <SHStack
              direction={"row"}
              width={"100%"}
              justifyContent={"space-between"}
            >
              <SHSkeleton width={150} height={35} delay={false} />
              <SHSkeleton width={100} height={35} delay={false} />
            </SHStack>

            <SHBox
              alignItems={"center"}
              justifyContent={"center"}
              sx={{
                border: `1px solid ${palette.secondary[100]}`,
              }}
            >
              <SHStack
                width={"100%"}
                direction={"row"}
                flexWrap={"wrap"}
                justifyContent={"center"}
              >
                {Array.from(Array(index === 0 ? 6 : 9).keys()).map((index) => (
                  <SHSkeleton
                    delay={false}
                    key={index}
                    sx={{
                      margin: "1% 1%",
                      display: "flex",
                    }}
                    height={
                      [3, 4, 5].includes(index)
                        ? 130
                        : [6, 7, 8].includes(index)
                        ? 170
                        : 160
                    }
                    width={"31%"}
                  />
                ))}
              </SHStack>
            </SHBox>
          </SHStack>
        ))}
      </SHStack>
    </SHContainer>
  );
};
